export const inputClass = "h-11 w-full rounded-lg border border-gray-300 px-4 text-sm shadow-xs placeholder:text-gray-400 focus:border-brand-300 focus:ring-3 focus:ring-brand-500/10 outline-none"
